import GroupsHistoryTable from "./GroupsHistoryTable";
export default GroupsHistoryTable;
